import create from './base'
import {stringify} from 'qs'
import {baseUrl} from '../config'

const http = create()
http.defaults.baseURL = baseUrl + '/api/infouser/v1'


//查询人员列表
const queryUser = (data) => {
    return http.get('/query?' + stringify(data))
}

// 保存|编辑人员信息
const saveOrupdateUser = ( infoList ) => {
    console.log(infoList.id)
    if(infoList.id != ''){
        return http.post('/update', stringify(infoList))
    }else{
        return http.post('/save', stringify(infoList))
    }
}

//查看详情(编辑)
const getUserInfo = (id) => {
    return http.get('/get?' + stringify({
        id
    }))
}

//查看详情(小眼睛)
const getEnrollUserInfo = (id) => {
    return http.get('/get_enroll?' + stringify({
        id
    }))
}

//删除单个人员
const delUserInfo = (id) => {
    return http.post('/delete?' + stringify({
        id
    }))
}

// 人员导入
const saveUploadFile = (
    schoolCode,
    userType,
    multipartFile,
) => {
    const formData = new FormData()
    formData.append('multipartFile', multipartFile)
    formData.append('userType', userType)
    formData.append('schoolCode', schoolCode)
    return http.post('/import_user', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
// 批量删除人员
const delBatchdelUserInfo = ( ids ) => {
    return http.post('/deleteBatch', stringify({
        ids
    }))
};

export default {
    queryUser,
    saveOrupdateUser,
    getUserInfo,
    delUserInfo,
    saveUploadFile,
    delBatchdelUserInfo,
    getEnrollUserInfo
}
